import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledAttachmentChipWrapper = styled(Box)(({ theme }) => ({
  width: 'fit-content',
  display: 'flex',
  alignItems: 'center',
  '.icons-wrapper': {
    display: 'none',
    alignSelf: 'center',
    gap: '4px',
    margin: '0 0 0 auto',
    paddingLeft: '5px',
    '& button': {
      height: '24px',
      width: '24px',
      padding: '5px 0',
    },
    '> *': {
      ':hover': {
        gap: '10px',
        backgroundColor: '#DFE5EE',
        borderRadius: '4px',
      },
      cursor: 'pointer',
    },
  },
  '&:hover': {
    '& .attachment-chip': {
      backgroundColor: theme.palette.background.selected_and_hover,
    },
    '.icons-wrapper': {
      display: 'flex',
      alignItems: 'center',
    },
  },
}));

export const StyledAttachmentChip = styled(Box)(({ theme, className, isDisabled }) => ({
  className,
  background: '#EDEFF1',
  opacity: isDisabled ? 0.6 : 1,
  borderRadius: theme.shape.border.borderRadius,
  display: 'flex',
  alignItems: 'center',
  padding: '6px',
  color: theme.palette.text.secondary_txt,
  fontWeight: '700',
  fontSize: '12px',
  width: '190px',
  height: '36px',
  '.attachment-icon': {
    marginRight: '10px',
    width: '24px',
    height: '24px',
  },
  '> span': {
    whiteSpace: 'nowrap',
    fontSize: '12px',
    lineHeight: '20px',
  },
}));
